var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 24 24",
    fill: "primary",
    className: "css-zbzjbd e11k6mr30",
    style: {
      minWidth: 40,
      minHeight: 40
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F26322",
    d: "M12.01 0 2 5.786V17.35L4.858 19 4.84 7.442l7.15-4.14 7.152 4.14v11.553L22 17.35V5.777L12.01 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F26322",
    d: "m13.335 19.051-1.333.792-1.337-.788V8L8 9.579l.004 11.05L12.002 23 16 20.63V9.579L13.335 8v11.051Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagento);
export default __webpack_public_path__ + "static/media/Magento.deb0dbf4dfae6d4df79eda3f74b0cb1a.svg";
export { ForwardRef as ReactComponent };